import * as React from 'react'

import * as heading from '../styles/heading'

type HighlightedTitleProps = heading.HighlightedTitleProps & React.HTMLAttributes<HTMLSpanElement>

export function HighlightedTitle({ children, ...props }: HighlightedTitleProps) {
  return <heading.HighlightedTitle {...props}>{children}</heading.HighlightedTitle>
}
